<template>
  <div class="wrap">
    <div class="nav" :class="menuPointer ? 'pEvents' : 'pEventsAuto'">
      <img
        src="../assets/img/nav/logo.png"
        alt=""
        srcset=""
        class="game-logo"
      />

      <div class="menu">
        <nav>
          <ul class="header-nav_list">
            <li
              class="header-nav_item"
              v-for="item in navlist"
              :key="item.id"
              @click="handleNav(item.id)"
              :class="menuPointer ? 'pEvents' : 'pEventsAuto'"
            >
              <img :src="activeIndex == item.id ? item.activeUrl : item.url" />
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <div class="blog" :class="menuPointer ? 'pEvents' : 'pEventsAuto'">
      <div class="b-icon">
        <img
          v-for="idx in 4"
          :key="idx"
          :src="require('../assets/img/nav/c-' + idx + '.png')"
          alt=""
          srcset=""
          @click="handleIcon(idx)"
        />
      </div>
      <img
        class="reg-m cursor"
        src="../assets/img/nav/reg-m.png"
        @click="handleModelReg()"
      />
    </div>
    <!-- 点击显示底栏的按钮 -->
    <div class="copyright-btn cursor" @click="cRightFlag = !cRightFlag">LEGAL</div>
    <div class="page">
      <swiper
        :options="swiperOption"
        ref="goodSwiper"
        @slideChange="slideChange"
      >
        <swiper-slide>
          <layer1 @handleReg="handleReg" />
        </swiper-slide>
        <swiper-slide>
          <layer2 @handleMenuIndex="handleMenuIndex($event)" />
        </swiper-slide>
        <swiper-slide>
          <layer3 ref="layer3" />
        </swiper-slide>
        <swiper-slide>
          <layer4 />
        </swiper-slide>
      </swiper>
    </div>

    <!-- 点击显示预注册弹出框 -->
    <div class="model reg-idx-model" v-if="regModel">
      <div class="reg-idx-cnt">
        <img
          src="../assets/img/layer2/p-title.png"
          alt=""
          srcset=""
          class="p-title"
        />
        <div class="idx-cnt">
          <div class="p-reg">
            <reg />
          </div>
          <img
            src="../assets/img/layer2/close.png"
            alt=""
            srcset=""
            class="close cursor"
            @click="regModel = false"
          />
        </div>
      </div>
    </div>

    <!-- 提示复制成功 -->
    <div class="model copy-model" v-if="copyModel">
      <img
        src="../assets/img/nav/copyAlert.png"
        alt=""
        srcset=""
        class="copyAlert"
        @click="copyModel = false"
      />
    </div>
    <!-- 底栏 copyright -->
    <div 
    :class="cRightFlag ? 'f-open' : ''"
    class="f-copyright" >
      <img src="../assets/img/nav/t-1.png" alt="" srcset="" class="t-1" />
      <div class="t-2">
       <a  href="https://useragreement-kr.ujoygames.co.kr/" target="_blank">
          <div class="btn-privacypolicy cursor"></div>
        </a>
        <a href="https://privacypolicy-kr.ujoygames.co.kr/" target="_blank">
          <div class="btn-useragreement cursor"></div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import layer1 from "./publicComponents/layer1";
import layer2 from "./publicComponents/layer2";
import layer3 from "./publicComponents/layer3";
import layer4 from "./publicComponents/layer4";
import reg from "./publicComponents/reg";

let _y = 0;
let _isEnd = false;

export default {
  components: {
    layer1,
    layer2,
    layer3,
    layer4,
    reg
  },
  data() {
    return {
      copyModel: false,
      cRightFlag: false,
      arrowFlag: true,
      nextShow: true,
      swiperOption: {
        direction: "vertical",
        slidesPerView: "auto",
        allowTouchMove: false,
        slideToClickedSlide: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        mousewheel: true, //开启鼠标
        noSwiping: false,
        noSwipingClass: "stop-swiping",
        initialSlide: 0,
        breakpoints: {
          780: {
            allowTouchMove: true
          }
        }
      },
      // menu
      navlist: [
        {
          id: 1,
          url: require("../assets/img/nav/1.png"),
          activeUrl: require("../assets/img/nav/1-active.png")
        },

        {
          id: 2,
          url: require("../assets/img/nav/2.png"),
          activeUrl: require("../assets/img/nav/2-active.png")
        },
        {
          id: 3,
          url: require("../assets/img/nav/3.png"),
          activeUrl: require("../assets/img/nav/3-active.png")
        },
        {
          id: 4,
          url: require("../assets/img/nav/4.png"),
          activeUrl: require("../assets/img/nav/4-active.png")
        }
      ],
      activeIndex: 1,
      menuPointer: false,
      regModel: false // 预注册弹出框
      // puserModel: false,//用户协议弹出框
    };
  },
  created() {},
  updated() {},

  mouthed() {},
  watch: {},
  computed: {},
  methods: {
    // 点击显示预注册弹出框
    handleModelReg() {
      this.regModel = true;
    },

    // 预注册错误弹出框出来后，禁止页面滑动
    // changeSilderDisable() {
    //   this.$refs.goodSwiper.swiper.mousewheel.disable();
    // },
    // changeSilderEnable() {
    //   this.$refs.goodSwiper.swiper.mousewheel.enable();
    // },

    // 改变菜单和顶栏的z-index
    handleMenuIndex(val) {
      this.menuPointer = val;

      if (val) {
        this.$refs.goodSwiper.swiper.mousewheel.disable();
      } else {
        this.$refs.goodSwiper.swiper.mousewheel.enable();
      }
    },
    handleIcon(val) {
      if (val == 1) {
        this.common.goShare("cafe");
      } else if (val == 2) {
        this.common.goShare("ins");
      } else if (val == 3) {
        this.onCopy();
      } else if (val == 4) {
        this.common.goShare("ko");
      }
    },
    // 复制按钮
    onCopy() {
      let url = "https://flower.ujoygames.com/";
      var oInput = document.createElement("input"); //创建一个隐藏input（重要！）
      oInput.value = url; //赋值
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = "oInput";
      oInput.style.display = "none";
      this.copyModel = true;
    },
    // 点击显示弹出框预注册页面
    handleReg() {
      this.$refs.goodSwiper.swiper.slideTo(1, 300);
    },

    // 菜单
    handleNav(val) {
      this.activeIndex = val;
      const hcon = this.$refs.goodSwiper.swiper;
      if (val == 1) {
        hcon.slideTo(0, 300);
      }
      if (val == 2) {
        hcon.slideTo(1, 300);
      }
      if (val == 3) {
        hcon.slideTo(2, 300);
      }
      if (val == 4) {
        hcon.slideTo(3, 300);
      }
    },

    slideChange() {
      const mainActiveIndex = this.$refs.goodSwiper.swiper.activeIndex;
      this.activeIndex = mainActiveIndex + 1;
      if (mainActiveIndex == 1) {
        // this.initData();
      }
    }
  }
};
</script>
<style lang="scss">
.wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-size: 100% auto;
  background-repeat: no-repeat;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #000;

  .pEvents {
    pointer-events: none;
    opacity: 0.5;
  }
  .pEventsAuto {
    pointer-events: auto;
    opacity: 1;
  }
  #copyright {
    height: 190px;
    width: 100%;
  }
  .copy-model {
    position: fixed;

    .copyAlert {
      width: 420px;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  // 预注册弹出框
  .reg-idx-model {
    position: absolute;
    .reg-idx-cnt {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .p-title {
        width: 420px;
        height: auto;
      }
      .idx-cnt {
        background-image: url("../assets/img/layer2/popup-bg.png ");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        width: 1200px;
        height: 628px;
        position: relative;
        top: 1vw;
        .close {
          width: 56px;
          height: auto;
          position: absolute;
          right: 0;
          top: -3.5vw;
        }
        .p-reg {
          width: 560px;
          position: absolute;
          right: 2.5vw;
          top: 4.5vw;
        }
      }
    }
  }
  // 轮播

  .page {
    .swiper-container {
      width: 100%;
      height: 100%;
    }
  }

  .blog {
    position: absolute;
    right: 1.5vw;
    top: 1vw;
    display: flex;
    align-items: end;
    flex-direction: column;
    gap: 2vw;
    z-index: 1;
    .b-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.3vw;
      img {
        display: block;
        width: auto;
        height: 54px;
      }
    }
    .reg-m {
      width: 121px;
      height: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainIndex.vue